import * as React from "react";

function SvgComponent(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="1em" height="1em" {...props}><path d="M8 .688c-1-.004-1.563 3.54-2.375 4.125-.812.584-4.344-.013-4.656.937-.313.95 2.882 2.578 3.187 3.531.305.953-1.338 4.128-.531 4.719.807.591 3.343-1.942 4.344-1.938 1 .005 3.5 2.585 4.312 2 .812-.584-.813-3.8-.5-4.75.313-.95 3.524-2.547 3.219-3.5-.305-.952-3.85-.377-4.656-.968C9.537 4.253 9 .69 8 .687zM7 5h2v2h2v2H9v2H7V9H5V7h2z" style={{
      marker: "none"
    }} color="#000" overflow="visible" fill="#474747" /></svg>;
}

export default SvgComponent;